import React, { useState, useEffect } from "react";
import style from "./Dashboard.module.css";
import MenuBar from "./MenuBar";
import { useNavigate, useLocation } from "react-router-dom";
import { API_BASE_URL } from "./config.js";
import HeadingBar from "./HeadingBar.js";

const Home = () => {
  const [powerBISrc, setPowerBISrc] = useState("");
  const [loading, setLoading] = useState(true);
  //const isEmbedded = sessionStorage.getItem("mode") === "embedded";
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ Detect embedded mode
  const params = new URLSearchParams(location.search);
  const modeFromUrl = params.get("mode");
  const modeFromSession = sessionStorage.getItem("mode");

  const isEmbedded =
    (modeFromUrl && modeFromUrl.toLowerCase() === "embedded") ||
    modeFromSession === "embedded";

  if (isEmbedded) {
    sessionStorage.setItem("mode", "embedded");
  }
  useEffect(() => {
    const init = async () => {
      const savedVendorData = sessionStorage.getItem("vendordata");

      // 1️⃣ If session exists → normal login flow
      if (savedVendorData) {
        const parsedData = JSON.parse(savedVendorData);
        setPowerBISrc(parsedData.U_PowerBI || "");
        setLoading(false);
        return;
      }

      // 2️⃣ Check URL params (embedded auto login)
      const vendor = params.get("vendor");
      const pass = params.get("pass");
      const auto = params.get("autologin");

      if (vendor && pass && auto === "1") {
        try {
          const response = await fetch(`${API_BASE_URL}/Login`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ UserId: vendor, Password: pass }),
          });

          const data = await response.json();

          if (response.ok && Array.isArray(data) && data.length > 0) {
            sessionStorage.setItem("vendordata", JSON.stringify(data[0]));
            setPowerBISrc(data[0].U_PowerBI || "");
          } else {
            navigate("/error");
          }
        } catch (err) {
          navigate("/error");
        } finally {
          setLoading(false);
        }
      } else {
        navigate("/login");
        setLoading(false);
      }
    };

    init();
  }, [navigate, location.search]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className={style.Home}>
      {/* ✅ Show HeadingBar only if NOT embedded */}
      {!isEmbedded && (
        <div className={style.HeadingBarContainer}>
          <HeadingBar />
        </div>
      )}

      <div className={style.HomeContainer}>
        <div className={style.MenuBarContainer}>
          <MenuBar />
        </div>

        <div className={style.MainHomePageContainer}>
          <div className={style.MainArea}>
            {powerBISrc ? (
              <div style={{ position: "relative", height: "100%" }}>
                <iframe
                  title="SalesReport"
                  src={powerBISrc}
                  frameBorder="0"
                  style={{ width: "100%", height: "100%", border: "none" }}
                />
                <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    height: 60,
                    width: "100%",
                    background: "#fff",
                    zIndex: 10,
                  }}
                />
              </div>
            ) : (
              <div style={{ color: "red" }}>
                Power BI report URL not found or invalid.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
